import _extends from "@babel/runtime/helpers/esm/extends";
import InputStyles from "../Input/styles";
export default {
  root: function root(theme) {
    return _extends({}, InputStyles.shared(theme), {
      height: 46,
      paddingRight: 0,
      paddingLeft: 0,
      width: '100%',
      '&:hover': InputStyles.hover(theme)
    });
  },
  disabled: function disabled(theme) {
    return InputStyles.disabled(theme);
  },
  error: function error(theme) {
    return _extends({}, InputStyles.error(theme), {
      '& .DateInput_input': {
        backgroundColor: theme.palette.error.background
      },
      '& .DateRangePickerInput': {
        backgroundColor: theme.palette.error.background
      }
    });
  },
  focused: function focused(theme) {
    return InputStyles.focused(theme);
  },
  inputContainer: {
    display: 'flex',
    flex: 1,
    width: 'calc(100% - 85px)',
    alignItems: 'center'
  }
};